//
import axios from "#/net/axios"

//
import { Toast } from "mint-ui"

/**
 * vuex
 */
const state = {
    notSameCityDistribution: {
        all: 0, // 全部
        customerServiceNum: 0, // 售后或退货
        deliveredNum: 0, // 已送达未确认收货
        unEvaluationNum: 0, // 待评价
        unPaidNum: 0, // 待付款
        unReceiptNum: 0, // 待收货
        unShippedNum: 0, // 待发货
    },

    sameCityDistribution: {
        all: 0,
        customerServiceNum: 0,
        deliveredNum: 0,
        unEvaluationNum: 0,
        unPaidNum: 0,
        unReceiptNum: 0,
        unShippedNum: 0,
    },

    selfPick: {
        all: 0,
        customerServiceNum: 0,
        deliveredNum: 0,
        unEvaluationNum: 0,
        unPaidNum: 0,
        unReceiptNum: 0,
        unShippedNum: 0,
    },

    shelfIdListWithMaxBuyNum: null,
}

const getters = {

}

const mutations = {
    setNotSameCityDistribution(state, data)
    {
        state.notSameCityDistribution = data;
    },

    setSameCityDistribution(state, data)
    {
        state.sameCityDistribution = data;
    },

    setSelfPic(state, data)
    {
        state.selfPick = data;
    },

    setShelfIdListWithMaxBuyNum(state, data) {
        state.shelfIdListWithMaxBuyNum = data;
    },
}

const actions = {
    getNotSameCityDistribution({ commit }) {
        axios.shop.get("orderController/orderStateCount.do").then(({statusCode, data, msg}) => {
            if (statusCode != '200' && statusCode != '401' && statusCode != '900')
            {
                return Toast(`getNotSameCityDistribution failed, ${msg}`)
            }
            else if (statusCode == '200') {
                commit("setNotSameCityDistribution", data)
            }
        }).catch(e => {
            Toast(`getNotSameCityDistribution throw exception, ${e.toString()}`)
        })
    },

    getSameCityDistribution({ commit }) {
        axios.shop.get("distributionOrder/orderStateCount.do").then(({statusCode, data, msg}) => {
            if (statusCode != '200' && statusCode != '401' && statusCode != '900')
            {
                // return Toast(`getSameCityDistribution failed, ${msg}`)
            }
            else if (statusCode == '200') {
                commit("setSameCityDistribution", data)
            }
        }).catch(e => {
            Toast(`getSameCityDistribution throw exception, ${e.toString()}`)
        })
    },

    getSelfPic({ commit }) {
        axios.shop.get("orderController/pickUpOrderStateCount.do").then(({statusCode, data, msg}) => {
            if (statusCode != '200' && statusCode != '401' && statusCode != '900')
            {
                return Toast(`pickUpOrderStateCount failed, ${msg}`)
            }
            else if (statusCode == '200')
            {
                commit("setSelfPic", data)
            }
            
        }).catch(e => {
            Toast(`pickUpOrderStateCount throw exception, ${e.toString()}`)
        })
    },

    getShelfIdWithMaxBuyNum({ commit }, {
        shopId,
    }, okCb) {
        //
        axios.shop
            .get('/shophome/getShopShelf.do', {
                shopId: shopId,
            })
            .then(({ statusCode, msg, data }) => {
                if (statusCode !== '200') {
                    return this.Toast(`获取货架最大购买数量失败, ${msg}`)
                }

                //
                commit("setShelfIdListWithMaxBuyNum", data);

                //
                if (okCb) {
                    setTimeout(() => {
                        okCb();
                    }, 50);
                }
            })
            .catch((e) => {
                Toast(`获取货架最大购买数量失败, ${e.toString()}`);
            })
            .finally(() => {

            });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
